import React from "react";

import { Highlightable } from "@packages/ds";
import { useCommandState } from "cmdk";

export function Highlighter(props: React.ComponentProps<typeof Highlightable>) {
  const { count } = useCommandState(state => state.filtered);
  const maxRowsToRerenderOnEachStateChange = 20;

  /**
   * The command menu list can have a big amount of items, lets say
   * 100. Everytime someone changes the search input each item rerenders to
   * wrap the seach value into the <mark></mark> element to highlight it,
   * which isn't optimal for performance as we are rerendering 100 items.
   * So we limit highlighting to when the search is less than 20 elements
   */
  return count > maxRowsToRerenderOnEachStateChange ? (
    props.textToHighlight
  ) : (
    <Highlightable {...props} shouldShowWithoutMatches />
  );
}
